module.exports = __webpack_public_path__ + "img/Warning.f263f630.svg";